module.exports = __webpack_public_path__ + "static/media/IMG_1845.377232c9.JPG";